import { Typography } from "@stardust-ds/react";
import intl from "react-intl-universal";

import DocumentIcon from "../../../assets/icons/DocumentIcon";
import DocumentReadyIcon from "../../../assets/icons/DocumentReadyIcon";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import ImageIcon from "../../../assets/icons/ImageIcon";
import TrashIcon from "../../../assets/icons/TrashIcon";
import VideoCameraIcon from "../../../assets/icons/VideoCameraIcon";
import styles from "./index.module.scss";
import { fnFormatDateFromDate } from "../../../utils/date";
import { useContext, useState } from "react";
import AuthContext from "../../../contexts/Auth";
import moment from "moment";

const aImagesExt = ["png", "jpg", "jpeg", "gif"];
const aVideosExt = ["mp4", "mkv", "avi", "mov", "webm"];

function RcmpEvidenceIcon(props) {
  const { cFileName, cDocumentType } = props;

  if (cDocumentType === "GED") return <DocumentIcon width="56" height="52" />;

  const cFileExt = cFileName?.split(".")?.pop() || "";

  if (aImagesExt.includes(cFileExt)) return <ImageIcon />;

  if (aVideosExt.includes(cFileExt)) return <VideoCameraIcon />;

  return <DocumentReadyIcon />;
}

function fnHandleDownloadFile(cUrl, cFileName) {
  const xhr = new XMLHttpRequest();
  xhr.responseType = "blob";
  xhr.onload = () => {
    const a = document.createElement("a");
    a.href = window.URL.createObjectURL(xhr.response);
    a.download = cFileName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
  };

  xhr.open("GET", cUrl);
  xhr.send();
}

export default function EvidencesCard(props) {
  const { data, removeFile, bShowRemoveButton } = props;
  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone
  const [nShowTollTipEvidence, fnSetNShowTollTipEvidence] = useState(-1)
  function removerUltimoNumeroDaString(string) {
    return string?.replace(/\d+(?![\d]+$)/, "");
  }

  function fnShowToollTipEvidence(event, id) {

    if (nShowTollTipEvidence !== -1) return;
    event.stopPropagation()
    event.preventDefault()
    const tdElement = event.currentTarget.firstChild;
    if (tdElement.scrollWidth > tdElement.clientWidth) {
      fnSetNShowTollTipEvidence(id);
    }
  }

  function fnHideToollTipEvidence() {
    if (nShowTollTipEvidence === -1) return
    fnSetNShowTollTipEvidence(-1);
  }

  const versionId = data.ged?.published_version?.ver_nid;

  let redirect = `${removerUltimoNumeroDaString(data.redirect)}${versionId}`;

  const dMomentFormated = moment.utc(data?.date, "DD/MM/YYYY - HH:mm").tz(cUserTimeZone).format("DD/MM/YYYY - HH: mm")
  return (
    <div className={styles.EvidencesCardContainer}>
      <div className={styles.EvidencesContent}>
        <div className={styles.documentIcon}>
          <RcmpEvidenceIcon cFileName={data.name} cDocumentType={data?.opae_ctype} />
        </div>
        <div className={styles.columnEvidencesCard}>
          <div className={styles.fileNameWrapper}>
            <div
              className={styles.fileName}
              onMouseEnter={(e) => fnShowToollTipEvidence(e, data.opae_nid)}

            >
              <h3
              >
                {data.name}</h3>
            </div>

            {nShowTollTipEvidence === data.opae_nid && (
              <div
                className={styles.toolltip}
                onMouseEnter={(e) => fnShowToollTipEvidence(e, data.opae_nid)}
                onMouseLeave={fnHideToollTipEvidence}

              >
                <p

                >{data.name}</p>
              </div>
            )}
          </div>
          <div className={styles.dataFile}>
            <div>
              <div className={styles.rowEvidencesCard}>
                <p className={styles.titleLabel}>
                  {intl.get("ActivityEvidence.date_sent")}
                </p>
                <Typography type="p2">{dMomentFormated}</Typography>
              </div>
              <div className={styles.rowEvidencesCard}>
                <p>Uploader:</p>
                <Typography type="p2">{data.user}</Typography>
              </div>
            </div>

            <div className={styles.downloadArea} >
              {data?.download && (
                <DownloadIcon
                  width={"15"}
                  height={"15"}
                  onClick={() => fnHandleDownloadFile(data.download, data.name)}
                />
              )}
              {data?.redirect && (
                <a href={redirect} target="_blank" rel="noreferrer">
                  <DownloadIcon width={"15"} height={"15"} />
                </a>
              )}
              {bShowRemoveButton && (
                <TrashIcon
                  width={"15"}
                  height={"15"}
                  fill={"#FF3541"}
                  onClick={() => removeFile(data)}
                />
              )}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
